import * as ng from 'angular';
import { StPaginationScroll } from './st-pagination-scroll.directive';

export const StPaginationScrollModule: string =
    ng.module('st-pagination-scroll', [
    ])
        .directive('stPaginationScroll', StPaginationScroll)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-pagination-scroll/st-pagination-scroll.module.ts